import React from 'react';
import { MenuItem } from '@mui/material';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import {CONNECTION_TYPE_MODEL, INPUT_NUMBER_DATA} from '../Model/Models';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CreateInputApp from '../Functionality/CreateInputApp';

const CreateInputModal = (props) => {
    const { onHide, controllerId = null, setModified } = props;

    const {
        t,
        resetValues,
        handleSubmit,
        input,
        handleChange,
        emptyFields,
        controllers,
        sioIds,
        getInputTypeConnections
    } = CreateInputApp({ onHide, controllerId, setModified });

    return (
        <CustomModal
            title='create_input'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                resetValues();
            }}
            onConfirm={() => {
                handleSubmit();
            }}
        >
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField id={"txt_cim_name"}
                                     trans={"name"}
                                     name={"name"}
                                     type={"text"}
                                     value={input.name}
                                     onChange={handleChange}
                                     required={true}
                                     emptyFields={emptyFields}
                                     length={128}
                    />
                </div>
                {controllerId == null &&
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSelectAndChildren id={"slt_cim_controller"}
                                                 name={"controllerId"}
                                                 trans={"controller"}
                                                 value={input.controllerId}
                                                 onChange={handleChange}
                                                 required={true}
                                                 emptyFields={emptyFields}
                                                 showNoSelectionOption={false}
                        >
                            {Array.isArray(controllers) &&
                            controllers.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>
                }

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cim_sio"}
                        name={"hidSioId"}
                        trans={"SIO"}
                        value={input.hidSioId}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                        disabled={!input.controllerId}
                    >
                        {Array.isArray(sioIds) &&
                            sioIds.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cim_number"}
                        name={"number"}
                        trans={"input_number"}
                        value={input.number}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                    >
                        {Object.values(INPUT_NUMBER_DATA).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cim_connection_type"}
                                             name={"typeConnection"}
                                             trans={"connection_type"}
                                             value={input.typeConnection}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                    >
                        {getInputTypeConnections.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {t(CONNECTION_TYPE_MODEL[item.id]?.trans)}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            </div>
        </CustomModal>
    );
};

export default CreateInputModal;
